import * as z from 'zod/mini'
import { queryArray } from '../../schemas/common'

export const getUsersCalendarEventsForEntityQuery = z.object({
  userIds: queryArray(z.array(z.uuid()).check(z.minLength(1))),
})
export type GetUsersCalendarEventsForEntityQuery = z.infer<typeof getUsersCalendarEventsForEntityQuery>

/** A managed user URL (`.../:userId`), checked by `ManagedUserGuard` against the caller. */
export const managedUserParams = z.object({ userId: z.uuid() })
export type ManagedUserParams = z.infer<typeof managedUserParams>
